import { appName, currentOrigin, generalBlue, lastDeployTimestamp } from 'src/app-config';
import { Link } from 'react-router-dom';
import { useGetIsMobile } from 'src/custom-hooks';

export const Footer = () => {
    const isMobile = useGetIsMobile();

    return (
        <>
        <div className={'main-footer'}
            style={{
                backgroundColor: generalBlue,
                height: isMobile ? '230px' : '190px',
                marginTop: '200px',
                paddingBottom: '20px',
                paddingTop: isMobile ? '10px' : '20px'
            }}
        >
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    fontSize: isMobile ? '1.4rem' : '2.2rem',
                    justifyContent: 'center',
                    marginInline: 'auto',
                    marginTop: '6px',
                    width: '100%'
                }}
            >
                <a href={currentOrigin} style={{ color: 'white', fontWeight: 'bolder', textDecorationLine: 'none' }}>
                    {appName}
                </a>
            </div>
            <div className={'text-center text-white ms-2'} style={{ fontSize: isMobile ? '0.7rem' : '0.9rem', fontWeight: 'normal' }}>
                Versión {new Date(lastDeployTimestamp).toLocaleString('es-AR', { hour12: false, hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' })} hs.
            </div>
            <h5 className={'text-center text-white mt-2 mb-3'}>
                <span style={{ fontSize: isMobile ? '1rem' : '1.3rem' }}>
                    Comunicación: asistentecongregacion@gmail.com
                </span>
            </h5>
            <div className={'d-flex flex-column flex-lg-row justify-content-center text-white text-center mt-2'}>
                <Link to={'/privacidad'}
                    className={`${isMobile ? '' : 'me-2'} text-white`}
                >
                    Política de Privacidad
                </Link>
                {!isMobile && '|'}
                <Link to={'/servicio'}
                    className={`${isMobile ? '' : 'mx-2'} text-white`}
                >
                    Términos de Uso
                </Link>
                {!isMobile && '|'}
                <Link to={'/sobre-nosotros'}
                    className={`${isMobile ? '' : 'mx-2'} text-white`}
                >
                    Sobre Nosotros
                </Link>
                {!isMobile && '|'}
                <Link to={'/instalar'}
                    className={`${isMobile ? '' : 'ms-2'} text-white`}
                >
                    Cómo instalar esta app
                </Link>
            </div>
        </div>
        </>
    );
}
